const validate = values => {
  const errors = {};

  if (values.email?.touched) {
    if (!values.email.value) {
      errors.email = 'Your email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(values.email.value)) {
      errors.email = 'Invalid email address';
    }
  }

  if (values.name?.touched) {
    if (!values.name.value) {
      errors.name = 'Your name is required';
    }
  }

  if (values.phone?.touched) {
    if (!values.phone.value) {
      errors.phone = 'Phone number required';
    } else if (
      !/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
        String(values.phone.value)
      )
    ) {
      errors.phone = 'Invalid phone number';
    }
  }

  if (values.website?.touched) {
    if (!values.website.value) {
      errors.website = 'Your website is required.';
    } else if (!/^[A-Z0-9.-_]+\.[A-Z]+$/i.test(values.website.value)) {
      errors.website = 'Invalid website address.';
    }
  }

  if (values.username?.touched) {
    if (!values.username.value) {
      errors.username = 'A username is required.';
    }
    //  else if (!/^@.{1,}/gmi.test(values.username.value)) {
    //   errors.username = 'Invalid username, must start with @.';
    // }
  }

  if (values.company?.touched) {
    if (!values.company.value) {
      errors.company = 'Your company name is required.';
    }
  }

  if (values.message?.touched) {
    if (!values.message.value) {
      errors.message = 'A message is required.';
    }
  }

  return errors;
};

export default validate;
